import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})
export class CacheService {
	private cache = new Map<string, { response: HttpResponse<any>; expiry: number }>();

	private baseUrl = 'https://api-cms.movilbus.pe/api/';

	get(url: string): HttpResponse<any> | undefined {
		const cached = this.cache.get(url);
		if (!cached) return undefined;
		if (Date.now() > cached.expiry) {
			this.cache.delete(url);
			return undefined;
		}
		return cached.response;
	}

	set(url: string, response: HttpResponse<any>): void {
		const expiry = Date.now() + 10 * 60 * 1000; // 5 minutos
		this.cache.set(url, { response, expiry });
	}

	isCacheable(url: string): boolean {
		return url.startsWith(this.baseUrl);
	}

	clear(): void {
		this.cache.clear();
	}
}
